import { Action } from 'redux';
import { Notification } from '@dev/ee-api/ee-api-models';

export enum ActionTypes {
    GET_ACC_NOTIFICATIONS = '@@notification/GET',
    UPDATE_NOTIFICATIONS = '@@notification/UPDATE',
    NOTIFICATION_ERROR = '@@notification/ERROR',
}

export interface GetAccountNotificatinsAction extends Action {
    type: ActionTypes.GET_ACC_NOTIFICATIONS;
}

export interface UpdateNotificationStoreAction extends Action {
    type: ActionTypes.UPDATE_NOTIFICATIONS;
    payload: {
        isLoading?: boolean;
        notificationList?: Notification[];
    };
}

export interface NotificationErrorAction extends Action {
    type: ActionTypes.NOTIFICATION_ERROR;
}

type DiscountNotification = Notification & {
    Content: {
        DiscountDurationMonths: string;
        DiscountPercent: string;
        PromoExpiry: string;
    };
};

export interface NotificationStore {
    isLoading?: boolean;
    notificationList?: DiscountNotification[];
}
